export const aciDoubleArrowLeft = {
    iconName: 'double-arrow-left',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M11.672 2.913c-.068.03-1.034.974-4.29 4.187-4.518 4.46-4.269 4.204-4.351 4.481-.041.137-.041.44 0 .577.082.277-.169.019 4.361 4.489 4.675 4.613 4.266 4.232 4.528 4.213a.414.414 0 00.213-.06.482.482 0 00.183-.615c-.016-.032-1.899-1.907-4.183-4.169a568.992 568.992 0 01-4.16-4.139c-.004-.016 1.728-1.744 4.152-4.143 2.287-2.264 4.172-4.143 4.19-4.177.111-.206.027-.488-.184-.62a.57.57 0 00-.46-.024zm8.643-.002c-.092.043-8.455 8.29-8.532 8.413-.11.178-.138.289-.138.545 0 .257.028.368.138.546.077.123 8.44 8.37 8.532 8.413a.6.6 0 00.407 0 .552.552 0 00.252-.277.532.532 0 00-.019-.377c-.018-.036-1.905-1.913-4.193-4.17-2.287-2.259-4.16-4.119-4.16-4.135 0-.015 1.873-1.876 4.16-4.133 2.288-2.258 4.175-4.135 4.193-4.171a.532.532 0 00.02-.378.551.551 0 00-.253-.277.6.6 0 00-.407.001z',
                fill: 'currentColor',
            },
        },
    },
};
